import { Point } from './point.model';
import { StoreyEntity } from './storey-entity.model';

export abstract class LocationEntity extends StoreyEntity {
    location: Point;
}
